import type { ReactElement } from 'react';
import { Prompt, Typography } from '@weareopenr/component-library';
import promptStyles from './MenuInUsePrompt.module.scss';

interface Props {
  open: boolean;
  closePrompt: VoidFunction;
  message?: string;
  menuName?: string;
}

export const MenuInUsePrompt = ({ open, closePrompt, message, menuName }: Props): ReactElement => {
  const [firstParagraph, ...restParagraphs] = (message?.split(/\r?\n\r?\n/) ?? []).filter(Boolean);

  return (
    <Prompt
      data-testid="menu-in-use-prompt"
      promptHeading={menuName ? `Unable to delete “${menuName}”` : 'Unable to delete menu'}
      closePrompt={closePrompt}
      open={open}
      backButton={true}
      backButtonText="Cancel"
      size="small"
    >
      {firstParagraph && (
        <Typography size="medium" weight="bold">
          {firstParagraph}
        </Typography>
      )}
      {restParagraphs.map((paragraph) => (
        <Typography key={paragraph} size="medium" className={promptStyles['prompt-text']}>
          {paragraph}
        </Typography>
      ))}
    </Prompt>
  );
};
